module.exports = __webpack_public_path__ + "static/media/wallet.e4a92490.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/wallet.svg
// module id = 1163
// module chunks = 0